import axios from 'axios';
import store from '@store/store';
import {logoutUser} from '@store/reducers/auth';
import {BASE_API} from '@app/const/AppSetting';

const intance = axios.create({
    baseURL: BASE_API,
    responseType: 'blob',
    headers: {
        'content-type': 'application/json'
    }
});

intance.interceptors.request.use(
    (request) => {
        const accessToken = localStorage.getItem(`token`);
        request.headers.Authorization = `Bearer ${accessToken}`;
        if(request.data)
            Object.keys(request.data).forEach(key => {
                if (request.data[key] === '') {
                    delete request.data[key];
                }
            });

        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

intance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.data.status === 401) {
            store.dispatch(logoutUser());
        }
        if (error.response.data.status === 403) {
            store.dispatch(logoutUser());
        }
        return Promise.reject(error);
    }
);

export default intance;
